export const profile = {
  title: 'Profil',
  subtitle: 'Kezeld a fiókod beállításait és biztonságát',
  
  sections: {
    personalInfo: 'Személyes adatok',
    security: 'Biztonság',
    mfa: 'Kétfaktoros hitelesítés',
  },

  personalInfo: {
    title: 'Személyes adatok',
    description: 'Frissítsd a profil adataidat',
    fullName: 'Teljes név',
    email: 'Email cím',
    phone: 'Telefonszám',
    role: 'Szerepkör',
    organization: 'Szervezet',
    photoUrl: 'Profilkép URL',
    updateProfile: 'Profil frissítése',
    updating: 'Frissítés...',
  },

  password: {
    title: 'Jelszó módosítása',
    description: 'Frissítsd a jelszavadat a fiókod védelme érdekében',
    currentPassword: 'Jelenlegi jelszó',
    newPassword: 'Új jelszó',
    confirmPassword: 'Új jelszó megerősítése',
    requirements: 'A jelszónak legalább 6 karakter hosszúnak kell lennie',
    changePassword: 'Jelszó módosítása',
    changing: 'Módosítás...',
  },

  mfa: {
    title: 'Kétfaktoros hitelesítés (MFA)',
    description: 'Extra biztonsági réteg a fiókod védelméhez',
    status: 'Státusz',
    enabled: 'Bekapcsolva',
    disabled: 'Kikapcsolva',
    enrolledAt: 'Bekapcsolva',
    lastUsed: 'Utoljára használva',
    never: 'Soha',
    enable: 'MFA bekapcsolása',
    disable: 'MFA kikapcsolása',
    reconfigure: 'Újrakonfigurálás',
    disableWarning: 'Biztosan kikapcsolod a kétfaktoros hitelesítést? Ez csökkenti a fiókod biztonságát.',
    disableConfirm: 'Igen, kikapcsolom',
    disableCancel: 'Mégse',
  },

  messages: {
    profileUpdated: 'Profil sikeresen frissítve!',
    passwordChanged: 'Jelszó sikeresen módosítva!',
    mfaEnabled: 'MFA sikeresen bekapcsolva!',
    mfaDisabled: 'MFA sikeresen kikapcsolva!',
    errorUpdatingProfile: 'Hiba a profil frissítése során',
    errorChangingPassword: 'Hiba a jelszó módosítása során',
    errorEnablingMfa: 'Hiba az MFA bekapcsolása során',
    errorDisablingMfa: 'Hiba az MFA kikapcsolása során',
    passwordMismatch: 'A jelszavak nem egyeznek',
    passwordTooShort: 'A jelszó túl rövid (minimum 6 karakter)',
    currentPasswordRequired: 'A jelenlegi jelszó megadása kötelező',
    wrongPassword: 'Hibás jelenlegi jelszó',
  },

  roles: {
    super_admin: 'Szuper Admin',
    admin: 'Admin',
    user: 'Felhasználó',
    customer: 'Ügyfél',
  },
}
